import e, { useEffect as n } from "react";
function t() {
  return (t = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }).apply(this, arguments);
}
var r = function r(e) {
    return n(function () {
      if (!window.__feedback_fish_injected__) {
        window.__feedback_fish_injected__ = !0;
        var n = document.createElement("script");
        n.src = "https://feedback.fish/ff.js?pid=" + e, n.defer = !0, n.addEventListener("error", function () {
          return n.remove();
        }), document.body.appendChild(n);
      }
    }, []);
  },
  i = function i(n) {
    if (r(n.projectId), !n.children) return null;
    var i = t({
      "data-feedback-fish": !0,
      "data-feedback-fish-userid": n.userId
    }, Object.keys(n.metadata || {}).reduce(function (e, r) {
      var i, d;
      return t({}, e, ((d = {})["data-feedback-fish-" + r] = null == n || null == (i = n.metadata) ? void 0 : i[r], d));
    }, {}));
    return /*#__PURE__*/e.isValidElement(n.children) ? /*#__PURE__*/e.cloneElement(n.children, i) : "function" == typeof n.children ? n.children(i) : null;
  };
export { i as FeedbackFish, r as useFeedbackFish };